import { ListboxOptions } from '@headlessui/react'
import clsx from 'clsx'
import * as React from 'react'

import type { InputSelectOptionsProps } from './type'

import { widths } from '@/components/ui/input/const'

export const InputSelectOptions = ({
  width = 'full',
  children,
}: InputSelectOptionsProps) => {
  return (
    <ListboxOptions
      anchor={'bottom'}
      transition
      portal
      style={{
        width: 'var(--button-width)',
      }}
      className={clsx([
        widths[width],
        'tw-absolute tw-w-fit',
        'tw-z-operationModal',
        '!tw-max-h-32 tw-min-h-8',
        'tw-py-1',
        'tw-rounded-md tw-bg-white tw-shadow-lg',
        'tw-ring-1 tw-ring-black tw-ring-opacity-5',
        'tw-cursor-pointer tw-overflow-auto',
        'tw-text-sm',
        'focus:tw-outline-none',
      ])}
    >
      {children}
    </ListboxOptions>
  )
}

InputSelectOptions.displayName = 'InputSelectOptions'
